import React, { useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ThemeProvider } from "./contexts/ThemeContext";

import Container from "./containers/Container";
import { APP_INITIALIZE_REQUESTED } from "./redux/constants/appConstants";


function App() {
  useEffect(() => {
    store.dispatch({ type: APP_INITIALIZE_REQUESTED });
  }, []);
  return (
    <Provider store={store}>
      <ThemeProvider>
        <Router>
          <Container />
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;